import { Routes, Route, Navigate } from 'react-router-dom';
import PublicHome from './pages/publicHome/publicHome';
import PublicInvite from './pages/publicInvite/publicInvite';

export default function UnauthenticatedContent() {
  return (
    <Routes>
      <Route path="/invite" element={<PublicInvite />} />
      <Route
        path='*'
        element={<PublicHome />}
      />
    </Routes>
  );
}
